import { render, staticRenderFns } from "./PrintGiftsReports.vue?vue&type=template&id=36d75b8f&scoped=true"
import script from "./PrintGiftsReports.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintGiftsReports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrintGiftsReports.vue?vue&type=style&index=0&id=36d75b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d75b8f",
  null
  
)

export default component.exports